var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticClass: "dashboard-widget",
      attrs: { "body-style": { padding: _vm.padding } }
    },
    [
      _c(
        "div",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _c("span", { staticClass: "dashboard-widget--title" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _vm._t("toolbox")
        ],
        2
      ),
      _vm._v(" "),
      _vm.scrollable
        ? _c(
            "el-scrollbar",
            { staticClass: "widget-scroll-pane" },
            [_vm._t("default")],
            2
          )
        : _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }